// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"c5625e6c","787":"dce0bb8e"}[chunkId] + ".chunk.js";
};